import clsx from 'clsx';
import React from 'react';
import { polymorphicFactory } from '../../factory/factory.utils.mjs';
import { Typography } from '../../Foundations/Typography/Typography.mjs';
import { Flex } from '../../Layout/Flex/Flex.mjs';
import classes from './Tab.module.css.mjs';
import { tabTypeClasses } from './Tab.utils.mjs';

const Tab = polymorphicFactory(
  (props, ref) => {
    const { text, component = "button", isSelected = false, variant = "horizontal", className, ...rest } = props;
    const isHorizontal = variant === "horizontal";
    return /* @__PURE__ */ React.createElement(Flex, { direction: isHorizontal ? "column" : "row" }, !isHorizontal && /* @__PURE__ */ React.createElement("div", { className: clsx(classes.verticalTabBar, isSelected ? classes.verticalTabBarSelected : classes.verticalTabBarUnselected) }), /* @__PURE__ */ React.createElement(
      Typography,
      {
        component,
        size: isHorizontal ? "label-medium-l" : "label-medium-m",
        type: component === "button" ? "button" : void 0,
        className: clsx(
          classes.tab,
          className,
          tabTypeClasses[variant],
          "kohler-tab-root",
          (rest["aria-expanded"] || isSelected) && classes.tabSelected
        ),
        ref,
        ...rest
      },
      text
    ), isSelected && isHorizontal && /* @__PURE__ */ React.createElement("div", { className: classes.horizontalTabBar }));
  }
);

export { Tab };
